import React from 'react'

import styles from './DangerMessage.module.scss'

const DangerMessage = ({ children }) => <div className={styles.dangerMessage}>{children}</div>

export default DangerMessage
